// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"151":"d3b09009","585":"a827dc22"}[chunkId] + ".chunk.js";
};